<template>
  <div class="custom-table-container">
    <table class="table table-hover custom-table" ref="postTable">
      <colgroup>
        <col v-for="column in fieldsToDisplay" :key="column.name" :width="column.width" />
      </colgroup>

      <thead>
        <tr class="text-center table-dark">
          <th v-for="column in fieldsToDisplay" :key="column.name" class="list-header">
            {{ column.name | formatColumnName }}
            <b-icon-triangle-fill v-if="column.sort === 'ASC'" font-scale="0.75" />
            <b-icon-triangle-fill flip-v v-else-if="column.sort === 'DESC'" font-scale="0.75" />
          </th>
        </tr>
      </thead>

      <tbody>
        <slot></slot>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "RequirementTable",
  props: {
    fieldsToDisplay: {
      type: Array,
    }

  },
  filters: {

    formatColumnName(name) {
      // 첫 글자를 대문자로 변경하고 중간에 대문자가 있는 경우 띄어쓰기 추가
      if (name.toUpperCase() === "ID") {
        // Exception. Id의 경우 모두 대문자로 변환하여 사용 - 20230614 박선익
        return name.toUpperCase()
      }
      return name.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
      });
    },
  },
  methods: {

  }
}

</script>
<style scoped>

@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.custom-table-container {
  margin-top: 1rem;
  padding: 0.566rem;
  border-radius: 20px;
  background-color: #F6F6FA;
}

.table.custom-table {
  margin-bottom: 0;
}

.table.custom-table tr {
  color: #2E2E38;
  background-color: #FFF;
}

.table.custom-table tr:hover {
  background-color: #FAFAFA;
}

.table.custom-table tr.deleted:hover {
  background-color: #fff
}

.table.custom-table thead th,
.table-bordered.custom-table th {
  height: 70px;
  padding: 0.244rem;
  /* padding: calc(0.75rem - 0.666rem); */
  background-color: #F6F6FA;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #C4C4CD;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  vertical-align: middle;
  white-space: nowrap;
}

.table.custom-table td {
  height: 90px;
  padding: 0.244rem;
  /* padding: 1.333rem 0.666vw; */
  border-top: 1px solid #E7E7EE;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  vertical-align: middle;
}

.table.custom-table td .title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table.custom-table td .title-wrap .title-container {
  flex-grow: 1;
}

.table.custom-table td .title-wrap .title-text {
  padding-left: 2.067rem;
  font-weight: 700 !important;
}


.table.custom-table tr:last-child td:first-child {
  border-radius: 0 0 0 10px;
}

.table.custom-table tr:last-child td:last-child {
  border-radius: 0 0 10px 0;
}

.table.custom-table .status-tag {
  display: inline-block;
  max-width: 100px;
  width: 100%;
  height: 29px;
  padding: 4px 6px;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  white-space: nowrap
}

.table.custom-table .status-tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}

.table.custom-table .overdue .status-tag.in-progress {
  background-color: #F5D6D6;
  color: #F00;
}

.table.custom-table .status-tag.to-do {
  background-color: #F6F6FA;
  color: #2E2E38;
}

.table.custom-table .status-tag.done {
  background-color: #CFDDFF;
  color: #1755CC;
}

.table.custom-table .status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}

.table.custom-table .status-tag.cancelled {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}
</style>